export enum FetchPaymentDataStatus {
    ACTIVE = 'active',
    EXPIRED = 'expired',
    PAID = 'paid',
    CANCELLED = 'cancelled',
    VIEWED = 'viewed'
}
